module.exports = function (mod) {
  console.log('SHOW VOCAB? ' + mod.show_vocab);
  var html = "\n\n    <div id=\"saito-container\" class=\"saito-container\">\n      <div class=\"saito-sidebar left\">\n\n\t<div class=\"menu\">\n\t  <div class=\"saito-menu\">\n            <ul class=\"saito-menu-list saito-sidebar-element\">\n\n              <li class=\"popup-home redsquare-menu-home redsquare-page-active\">\n                <i class=\"fa-solid fa-house\"></i>\n                <span>Home</span>\n              </li>\n\n              <li class=\"popup-lessons redsquare-menu-lessons redsquare-page-active\">\n                <i class=\"fa-solid fa-graduation-cap\"></i>\n                <span>Lessons</span>\n              </li>\n\t";
  if (mod.show_vocab) {
    /***
    <!---
              <li class="popup-notifications redsquare-menu-notifications">
                <i class="fas fa-bell"></i>
                <span>Notifications</span>
                <div class="saito-notification-dot" style="display: none;">0</div>
              </li>
    ---->
    ***/

    html += "\n              \t\t<li class=\"popup-vocab redsquare-menu-profile\">\n                \t\t<i class=\"fas fa-user\"></i>\n                \t\t<span>Vocab</span>\n              \t\t</li>\n\t\t";
  }
  html += "\n\n            </ul>\n          </div>\n        </div>\n\n      </div>\n\n\n      <div class=\"saito-main\">\n      </div>\n\n\n      <div class=\"saito-sidebar right\">\n      </div>\n\n\n\n    </div>\n  ";
  return html;
};